export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Invite-Gray-2d12eced258d3ce83b6edf3eb83a7d1c.svg";